var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "", "align-end": "" } },
    [
      _c(
        "v-flex",
        {
          staticStyle: { color: "#ddd" },
          attrs: { xs12: "", "white--text": "" }
        },
        [
          _c("p", { staticClass: "text-xs-center" }, [
            _vm._v("Copyright  ©  2017-2019 Construn. All Rights Reserved.")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-xs-center" }, [_vm._v("康思创版权所有")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }